import axios from "infra/http";
import { useQuery } from "react-query";

function useDescricaoPadraoArrecadacao(mes: string) {
  return useQuery(`/v1/arrecadacao/descricao-padrao`, async () => {
    const res = await axios.get<{ descricao: string }>(
      `/v1/arrecadacao/descricao-padrao`,
      {
        params: { mes },
      }
    );

    return res.data;
  });
}

export default useDescricaoPadraoArrecadacao;
